webpackJsonp([42016896774740],{

/***/ 1288:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProductSuggestionType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DIAGNOSTIC"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"IMMUNIZATION"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"MEDICATION"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"TREATMENT"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-product-suggestion-type-dd92f5a3887c00f6685a.js